module.exports = __webpack_public_path__ + "img/aniversarios-segundo-thumbnail.adc2c20b.jpg";